var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMexican(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA733"
    },
    d: "M416.885,479.381c0,0-6.401-134.096-160.692-134.096S95.115,479.405,95.115,479.405 c-0.041,0.512-2.5,32.599,26.961,32.595h267.849C419.624,512.004,416.885,479.381,416.885,479.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3F62"
    },
    d: "M416.885,479.381c0,0-1.582-32.939-21.961-66.166c-7.393,0.887-138.184,60.553-138.184,60.553 s-128.654-64.557-139.223-60.963c-20.716,33.376-22.401,66.6-22.401,66.6c-0.041,0.512-2.5,32.599,26.961,32.595h267.849 C419.624,512.004,416.885,479.381,416.885,479.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DC82A"
    },
    d: "M208.646,512h96.17l90.095-98.784c-10.089-16.448-24.779-32.967-46.169-45.595l-92.011,106.148 l-94.538-105.34c-20.329,12.303-34.511,28.125-44.409,43.946L208.646,512z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF9811"
    },
    cx: 127.87,
    cy: 302.279,
    r: 37.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFA733"
    },
    cx: 384.13,
    cy: 302.279,
    r: 37.639
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8700"
    },
    d: "M127.872,264.642c-8.127,0-15.645,2.585-21.796,6.963v15.719c0,17.615,3.064,34.527,8.669,50.241 c4.088,1.521,8.51,2.357,13.128,2.357c20.787,0,37.64-16.852,37.64-37.64C165.511,281.495,148.659,264.642,127.872,264.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8700"
    },
    d: "M384.128,264.642c8.127,0,15.645,2.585,21.796,6.963v15.719c0,17.615-3.064,34.527-8.669,50.241 c-4.088,1.521-8.51,2.357-13.128,2.357c-20.787,0-37.64-16.852-37.64-37.64C346.489,281.495,363.341,264.642,384.128,264.642z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC477"
    },
    d: "M256,104.062L256,104.062c-68.111,0-123.839,55.727-123.839,123.839v59.424 c0,68.111,55.727,123.839,123.839,123.839l0,0c68.111,0,123.839-55.727,123.839-123.839v-59.424 C379.839,159.79,324.111,104.062,256,104.062z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB655"
    },
    d: "M180.814,285.368v-59.424c0-58.068,40.509-107.127,94.661-120.333 c-6.349-1.014-12.853-1.548-19.476-1.548l0,0c-68.111,0-123.839,55.728-123.839,123.839v59.424 c0,68.111,55.728,123.839,123.839,123.839l0,0c10.043,0,19.812-1.22,29.176-3.504C226.232,398.245,180.814,346.856,180.814,285.368z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E3D42"
    },
    d: "M314.339,297.578c-15.382-16.124-40.121-17.928-57.6-5.045c-17.478-12.883-42.219-11.079-57.6,5.045 c-16.689,17.493-44.126,74.649-26.632,91.338c15.832,15.102,63.037-8.115,84.233-25.629c21.195,17.514,68.401,40.733,84.233,25.629 C358.464,372.227,331.026,315.071,314.339,297.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D2D30"
    },
    d: "M233.606,303.959c6.113-6.408,13.704-10.546,21.73-12.407c-17.379-11.787-41.222-9.669-56.197,6.03 c-16.689,17.493-44.126,74.649-26.632,91.338c6.504,6.205,18.306,5.934,31.421,2.256 C193.31,370.725,218.096,320.217,233.606,303.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA733"
    },
    d: "M256.738,257.612c-12.124,0-22.044,9.919-22.044,22.044v13.589c0,12.124,9.919,22.044,22.044,22.044 c12.124,0,22.044-9.919,22.044-22.044v-13.589C278.783,267.533,268.862,257.612,256.738,257.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M256.738,293.245v-13.589c0-8.111,4.453-15.218,11.022-19.046c-3.249-1.894-7.009-2.998-11.022-2.998 c-12.124,0-22.044,9.919-22.044,22.045v13.589c0,12.124,9.919,22.044,22.044,22.044c4.012,0,7.772-1.104,11.022-2.998 C261.19,308.465,256.738,301.357,256.738,293.245z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E3D42"
    },
    d: "M201.354,266.018c-2.209,0-4.371-0.897-5.94-2.455c-1.569-1.568-2.466-3.732-2.466-5.95 c0-2.208,0.896-4.382,2.466-5.94c1.568-1.568,3.73-2.465,5.94-2.465c2.218,0,4.382,0.896,5.95,2.465 c1.559,1.568,2.455,3.732,2.455,5.94c0,2.218-0.896,4.382-2.455,5.95C205.737,265.121,203.573,266.018,201.354,266.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E3D42"
    },
    d: "M316.856,266.018c-2.209,0-4.371-0.897-5.94-2.455c-1.569-1.568-2.466-3.732-2.466-5.95 c0-2.208,0.896-4.382,2.466-5.941c1.568-1.568,3.73-2.465,5.94-2.465c2.218,0,4.382,0.896,5.95,2.465 c1.559,1.568,2.455,3.733,2.455,5.941c0,2.218-0.896,4.382-2.455,5.95C321.239,265.121,319.075,266.018,316.856,266.018z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7956"
    },
    d: "M330.663,59.506l-73.472-7.304l-75.163,7.304c-18.992,34.264-33.667,79.27-44.293,123.903h236.528 C364.068,138.776,349.737,93.77,330.663,59.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6243"
    },
    d: "M255.332,0c-57.516,0-95.954,92.496-117.596,183.408h96.958 c14.999-63.005,38.067-126.759,69.959-159.971C290.216,8.727,273.829,0,255.332,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DC82A"
    },
    d: "M182.036,59.506H330.67C310.893,23.977,286.014,0,255.341,0C226.061,0,201.729,23.977,182.036,59.506 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5EAC24"
    },
    d: "M304.653,23.438c-0.004-0.005-0.009-0.01-0.014-0.016C290.209,8.72,273.829,0,255.341,0 c-29.279,0-53.612,23.977-73.304,59.506h96.962C286.814,45.41,295.355,33.119,304.653,23.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9478"
    },
    d: "M490.341,111.129H21.659c-21.247,0-19.972,16.858-19.972,16.858s-0.019,62.524,79.216,95.339 c0,0,12.287,5.661,38.491,5.661h273.213c26.204,0,38.491-5.661,38.491-5.661c79.234-32.815,79.216-95.339,79.216-95.339 S511.589,111.129,490.341,111.129z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7956"
    },
    d: "M119.949,127.985c0,0-1.274-16.858,19.972-16.858H21.659c-21.247,0-19.972,16.858-19.972,16.858 s-0.019,62.525,79.216,95.34c0,0,12.287,5.661,38.491,5.661h118.264c-26.204,0-38.491-5.661-38.491-5.661 C119.932,190.51,119.949,127.985,119.949,127.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7956"
    },
    d: "M364.351,205.507h-9.913c-4.323,0-7.826-3.503-7.826-7.826s3.503-7.826,7.826-7.826h9.913 c4.323,0,7.826,3.503,7.826,7.826S368.674,205.507,364.351,205.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7956"
    },
    d: "M329.22,205.507h-56.349c-4.323,0-7.826-3.503-7.826-7.826s3.503-7.826,7.826-7.826h56.349 c4.323,0,7.826,3.503,7.826,7.826S333.543,205.507,329.22,205.507z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexican);
export default __webpack_public_path__ + "static/media/mexican.7ce8d1cfc1b90fcff699e56867e2a8ee.svg";
export { ForwardRef as ReactComponent };